import { useEffect, useRef } from 'react';
export const useTextareaRef = (props) => {
    const { focus } = props;
    const textareaRef = useRef(undefined);
    // Focus
    useEffect(() => {
        if (focus && textareaRef.current) {
            textareaRef.current.focus();
        }
    }, [focus]);
    return {
        textareaRef,
    };
};
